var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotspotInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9974 18.6667C15.2861 18.6667 16.3307 17.622 16.3307 16.3333C16.3307 15.0447 15.2861 14 13.9974 14C12.7087 14 11.6641 15.0447 11.6641 16.3333C11.6641 17.622 12.7087 18.6667 13.9974 18.6667Z",
    stroke: "#070707",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66538 23.3358C3.14751 21.3176 2.32841 18.8599 2.33204 16.3346C2.33204 9.89114 7.55521 4.66797 13.9987 4.66797C20.4422 4.66797 25.6654 9.89114 25.6654 16.3346C25.6654 18.962 24.7974 21.3863 23.332 23.3358",
    stroke: "#070707",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78267 21.0028C7.88176 19.9956 7.29163 18.7492 7.08352 17.414C6.8754 16.0788 7.05821 14.7119 7.60986 13.4783C8.16151 12.2447 9.05843 11.1972 10.1923 10.4621C11.3263 9.72707 12.6487 9.33594 14 9.33594C15.3513 9.33594 16.6738 9.72707 17.8077 10.4621C18.9416 11.1972 19.8385 12.2447 20.3901 13.4783C20.9418 14.7119 21.1246 16.0788 20.9165 17.414C20.7084 18.7492 20.1182 19.9956 19.2173 21.0028",
    stroke: "#070707",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotspotInactive);
export default __webpack_public_path__ + "static/media/hotspotInactive.f431631ffa5e8e6fdd0340b2be45be55.svg";
export { ForwardRef as ReactComponent };